import { render, staticRenderFns } from "./OrdersDatatable.vue?vue&type=template&id=68e5f333&scoped=true"
import script from "./OrdersDatatable.vue?vue&type=script&lang=ts"
export * from "./OrdersDatatable.vue?vue&type=script&lang=ts"
import style0 from "./OrdersDatatable.vue?vue&type=style&index=0&id=68e5f333&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e5f333",
  null
  
)

export default component.exports